var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSsvNetwork = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M12.5813 23.372L15.4236 19.8775C15.7204 19.5125 16.279 19.5125 16.5758 19.8775L19.4181 23.372C19.6392 23.644 19.6392 24.0327 19.4181 24.3046L16.5758 27.7993C16.279 28.1641 15.7204 28.1641 15.4236 27.7993L12.5813 24.3046C12.3603 24.0327 12.3603 23.644 12.5813 23.372Z",
    fill: "#2DB1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9975 14.8263L19.8397 11.3316C20.1365 10.9668 20.6952 10.9668 20.9919 11.3316L23.8342 14.8263C24.0553 15.0982 24.0553 15.4868 23.8342 15.7588L20.9919 19.2535C20.6952 19.6184 20.1365 19.6184 19.8397 19.2535L16.9975 15.7588C16.7764 15.4868 16.7764 15.0982 16.9975 14.8263Z",
    fill: "#2DB1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16582 14.8263L11.0081 11.3316C11.3049 10.9668 11.8635 10.9668 12.1603 11.3316L15.0026 14.8263C15.2236 15.0982 15.2236 15.4868 15.0026 15.7588L12.1603 19.2535C11.8635 19.6184 11.3049 19.6184 11.0081 19.2535L8.16582 15.7588C7.94473 15.4868 7.94473 15.0982 8.16582 14.8263Z",
    fill: "#2DB1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5813 9.36388L15.4236 5.8688C15.7204 5.50394 16.279 5.50394 16.5758 5.8688L19.4181 9.36346C19.6392 9.63541 19.6392 10.024 19.4181 10.296L16.5758 13.7906C16.279 14.1555 15.7204 14.1555 15.4236 13.7906L12.5813 10.2964C12.3603 10.0245 12.3603 9.63541 12.5813 9.36388Z",
    fill: "#2DB1FF"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSsvNetwork);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ssv-network.e51269543df1a5e785ea6baf3ad2de67.svg";